import styled from 'styled-components';

export const Wrap = styled.div`

`;

export const BottomWrap = styled.div`
  position: relative;

  > button {
    border: 0;
    background: transparent;
    width: 75.5%;
    height: 10%;
    position: absolute;
    top: 27%;
    left: 50%;
    transform: translateX(-50%);
  }
`;
